export default {
  name: 'Modal'
}
